import { DisplayValues } from '../../types/video-form';

import { PreviewImage } from './preview-image/preview-image';
import { Subtitles } from './subtitles/subtitles';
import { Title } from './title/title';

type Props = {
  displayValues: DisplayValues;
  updateValue: (field: string, value: File | string | undefined) => void;
  setTitleError: (error: boolean) => void;
  onError: (error: string) => void;
};
export const VideoForm: React.FC<Props> = ({
  displayValues,
  setTitleError,
  updateValue,
  onError,
}) => {
  const bindUpdateValue =
    (field: string) => (value: File | string | null | undefined) =>
      updateValue(field, value ?? undefined);

  return (
    <>
      <Title
        title={displayValues.title}
        setTitle={bindUpdateValue('title')}
        setError={setTitleError}
      />
      <PreviewImage
        previewImageDisplay={displayValues.previewImage}
        onUpload={bindUpdateValue('previewImage')}
        onDelete={() => updateValue('previewImage', undefined)}
        onError={onError}
      />
      <Subtitles
        displayEn={displayValues.englishSubtitle}
        displayDe={displayValues.germanSubtitle}
        setSubtitleEn={bindUpdateValue('englishSubtitle')}
        setSubtitleDe={bindUpdateValue('germanSubtitle')}
        onError={onError}
      />
    </>
  );
};
